<div class="auth-wrapper auth-v1 px-2" *ngIf="coreConfig">
  <div class="auth-inner py-2">
    <div class="card mb-0">
      <div class="card-header justify-content-center bg-secondary">
        <a href="#" target="_self" class="brand-logo mb-0 mt-0">
          <img src="{{ coreConfig.app.logo.light }}" alt="brand-logo" height="50"/>
        </a>
      </div>

      <div class="card-body pt-2">
        <ng-container *ngIf="businessItems.length > 0">
          <h2>Siamo felici di rivederti!</h2>

          <h5>Scegli l'azienda con cui fare accesso</h5>

          <!-- Search Box -->
          <div class="search-bar">
            <div class="search-icon">
              <i class="fa fa-search"></i>
            </div>

            <input type="text" [placeholder]="placeholderText" (input)="onSearch($event)" [(ngModel)]="searchQuery"/>

            <div class="clear-icon" (click)="clearSearch()">
              <i class="fa fa-times"></i>
            </div>
          </div>

          <!-- List of Items -->
          <div class="business-list col-12">
            <div *ngFor="let item of businessItems; index as i" class="business-item" (click)="identifyUserWithBusinessCode(item.id)">
              <div class="row-number">{{ i+1 }}</div>

              <div class="business-info">
                <div class="business-name">{{ item.name }}</div>

                <div class="partita-iva">IVA {{ item.vat }}</div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="tmpBusinessItems.length === 0 ">
          <h2>Benvenuto su Tulero!</h2>
          <p class="mt-2">Grazie per la tua iscrizione! Manca ancora un piccolo passo per iniziare ad acuistare, REGISTRA LA TUA AZIENDA</p>

          <button class="btn btn-secondary full-width text-center mt-5" (click)="businessRegister()">Registra la tua azienda</button>
        </ng-container>

        <button class="submit" type="submit" (click)="signOut()">Logout</button>
      </div>

      <div class="auth-box" *ngIf="businessItems.length > 0">
        <p class="cursor-pointer">hai un'attività?</p>

        <p class="toggle" (click)="businessRegister()">registra la tua attività qui</p>
      </div>
    </div>
  </div>
</div>
